import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {deleteTestAction} from "features/model/slice/test/success-test/delete-test/deleteTest";


export const deleteTest = createAsyncThunk(
    "lessons/deleteTest",
    async (testId: string | undefined, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);
            const response = await axios.delete(`/api/tests/${testId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.success) {
                thunkAPI.dispatch(deleteTestAction(response.data));
            } else {
                console.error("Ошибка при обновлении теста:", response.data.error);
            }
            return response.data;
        } catch (error) {
            console.error("An error occurred:", error);
            return thunkAPI.rejectWithValue("Error deleting file.");
        }
    }
);
